import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const tersusContainerBarcodeFileDataSchema = yup.object().shape({
  containerId: yup.string().nullable().optional(),
  clientName: yup.string().nullable().optional(),
  shipmentId: yup.string().nullable().optional(),
  locationCode: yup.string().nullable().optional(),
  date: yup.string().nullable().optional(),
  barcode: yup.string().nullable().optional(),
})

export type TersusContainerBarcodeFileData = yup.InferType<
  typeof tersusContainerBarcodeFileDataSchema
>

type RequiredFileData = MakeRequiredAndNullable<TersusContainerBarcodeFileData>

export const tersusContainerBarcodeFileMappings: RequiredFileData = {
  containerId: '5d649d2e-47d1-4a7f-9c70-2d5d18cbf0af',
  clientName: 'f52fae41-8053-4637-b4b1-2097147dbd02',
  shipmentId: 'b9d5a20a-d9b8-4a61-a02c-93f9ab3c59e7',
  locationCode: 'f57a0e10-98d0-43cc-8f1c-1e028d6c3101',
  date: 'f3a1c89f-88c4-4c42-9b08-3c3b6e0ad812',
  barcode: '6cbe7f72-4a70-41cf-92a2-3d4ff6d58f71',
}

export const mockTersusContainerBarcodeFileData: RequiredFileData = {
  containerId: 'CONTAINER-1',
  clientName: 'THE NORTH FACE',
  shipmentId: 'SHIPMENT-1',
  locationCode: 'NBU',
  date: '2025-11-25',
  barcode:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAyCAIAAACMIyF9AAAAbklEQVR4nO3PMQrAMAwEwSP///O5SBOwsNsN7FSyEYhNkrZt3yHJPuzP7/9h+bB23Rxvjeee/J8NDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA8MCXyNaCS3W+zgAAAAASUVORK5CYII=',
}
